import { render, staticRenderFns } from "./tourists.vue?vue&type=template&id=57f4e6d7&scoped=true"
import script from "./tourists.vue?vue&type=script&lang=js"
export * from "./tourists.vue?vue&type=script&lang=js"
import style0 from "./tourists.vue?vue&type=style&index=0&id=57f4e6d7&prod&scoped=true&lang=css"
import style1 from "./tourists.vue?vue&type=style&index=1&id=57f4e6d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f4e6d7",
  null
  
)

export default component.exports